/**
 * HISTORICAL PERFORMANCE DATA
 * Annualized or Period-Specific returns for major asset classes during crisis events.
 */
export const historicalScenarios = [
  {
    id: '2008-crash',
    name: '2008 Great Recession',
    period: '2007 - 2009',
    description: 'The subprime mortgage crisis led to a massive stock market collapse. Gold emerged as the ultimate safe haven.',
    data: {
      stocks: -37.0, // S&P 500 2008
      bonds: 5.2,   // 10-Year Treasury
      gold: 5.5,    // Gold Spot
    },
    insight: 'While the S&P 500 plummeted 37%, gold actually gained value. A portfolio with 20% gold would have mitigated nearly a quarter of the total losses.'
  },
  {
    id: '1970s-stagflation',
    name: '1970s Stagflation',
    period: '1973 - 1979',
    description: 'High inflation combined with stagnant growth. Stocks and bonds struggled, while gold experienced its greatest bull market.',
    data: {
      stocks: -14.7, // Real returns were negative
      bonds: -5.0,
      gold: 1300.0, // Total decade growth was explosive
    },
    insight: 'During the 1970s, traditional assets lost value in real terms. Gold was the only asset class that significantly outpaced the high inflation of the era.'
  },
  {
    id: '2022-inflation',
    name: '2022 Inflation Spike',
    period: '2022',
    description: 'The first time in 50 years where both stocks and bonds crashed simultaneously, leaving traditional 60/40 investors unprotected.',
    data: {
      stocks: -18.2, 
      bonds: -13.0,
      gold: -0.8,
    },
    insight: 'In 2022, bonds failed as a hedge. Gold remained virtually flat, providing a "volatility floor" that prevented total portfolio double-digit devastation.'
  },
  {
    id: 'dot-com',
    name: '2000 Dot Com Bubble',
    period: '2000 - 2002',
    description: 'The tech-heavy NASDAQ crashed. Investors who were over-indexed in "paper" tech stocks saw their retirements vanish.',
    data: {
      stocks: -49.0,
      bonds: 21.0,
      gold: 12.5,
    },
    insight: 'Diversification into non-correlated assets like gold and treasuries allowed investors to offset nearly half of the NASDAQ\'s total drawdown.'
  }
];